import { render, staticRenderFns } from "./NextHopGroupList.vue?vue&type=template&id=38e81cd3&"
import script from "./NextHopGroupList.vue?vue&type=script&lang=js&"
export * from "./NextHopGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports